import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Button from "react-bootstrap/Button";

const VisitorLanguage = (props) => {
  // visitor language component which dynamically sets the language from museum mutimedia
  const [languageSelected, setLanguageSelected] = useState(props.language);
  //state to store the language component
  const [
    LanguagesToDisplayComponents,
    setLanguagesToDisplayComponents,
  ] = useState();

  useEffect(() => {
    // calls and updates the display components if language selected is changed 
    setLanguagesToDisplayFromMuseumProps();
  }, [languageSelected]);

  const removeDuplicateValues = (data) => {
    return [...new Set(data)];
  };

  const setLanguagesToDisplayFromMuseumProps = () => {
    let displayLanguages = [];
    let displayComponents = [];
    for (let a = 0; a < props.museum.museum_multimedia.length; a++) {
      displayLanguages.push(props.museum.museum_multimedia[a].lang);
    }
    displayLanguages = removeDuplicateValues(displayLanguages);
    displayComponents = displayLanguages.map((currentLanguage, index) => {
      return (
        <div key={index}>
          <label>
            <input
              onChange={(event) => onClick(event)}
              type="radio"
              name="language"
              value={currentLanguage}
              checked={languageSelected === currentLanguage}
            />
            <span
              className={
                languageSelected === currentLanguage
                  ? "visitorlanguage-checkbox-active"
                  : "visitorlanguage-checkbox"
              }
            >
              {currentLanguage}
            </span>
          </label>
          <hr
            className={
              languageSelected === currentLanguage
                ? "visitorlanguage-line-active"
                : "visitorlanguage-line"
            }
          />
        </div>
      );
    });

    setLanguagesToDisplayComponents(displayComponents);
  };

  const onClick = (event) => {
    setLanguageSelected(event.target.value);
  };

  const onNext = () => {
    if (languageSelected !== "") {
      props.selectLanguage(languageSelected);
    }
  };
  return (
    <div className="visitorlanguage-page-layout">
      <p className="visitorlanguage-page-heading">
        Please select your language
      </p>
      <form>{LanguagesToDisplayComponents}</form>
      <Button
        disabled={languageSelected === ""}
        id="visitorlanguage-next-button"
        onClick={onNext}
      >
        Next
      </Button>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    museum: state.museumData.museumData,
  };
};

export default connect(mapStateToProps, null)(VisitorLanguage);
